export default "__VITE_ASSET__46c1d39f__"